/**
 * RISK-IMPORT-ORDER
 * Confirm order for the columns
 */

import ConfirmButtons from "@/components/confirm-buttons"
import ListItem from "@/components/list-item"
import AccountOptionsRiskAttributes from "@/features/adm/entities/account/ui/AccountOptionsRiskAttributes"
import { useState } from "react"
import { RiskMapping } from "../model/risk.types"

interface Props {
  onConfirm: Function
  mapping: RiskMapping
}

export function RisksImportOrder(props: Props) {
  const [attributes, setAttributes] = useState<string[]>(
    props.mapping.importColumns.filter((x) => x.isCustom && x.mapping).map((x) => x.mapping as string)
  )

  function confirm() {
    props.onConfirm(attributes)
  }

  return (
    <div>
      <AccountOptionsRiskAttributes attributes={attributes} reorderAttributes={(newKeys) => setAttributes(newKeys)} />
      <ListItem>
        <b>La modification des colonnes sera toujours possible plus tard dans les paramètres du compte.</b>
      </ListItem>
      <ConfirmButtons onConfirm={() => confirm()} />
    </div>
  )
}
